import React from 'react'
import { Box, Button, Grid, IconButton, Link, Paper, Stack, styled, Typography, useMediaQuery } from '@mui/material'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import logo from '../assests/rplogo2.png';
import { Link as RouterLink } from 'react-router-dom';

const StyledBtn = styled(Button)(({ theme, Matches }) => ({
    display: 'inline-block',
    textAlign: Matches ? '' : 'center',
    color: '#fff',
    background: '#978A7D',
    borderRadius: '80px',
    fontSize: '14.5px',
    padding: '0px 25px',
    fontWeight: 700,
    transition: '0.15s',
    width: '100%',
    maxWidth: '220px',
    minWidth: '190px',
    height: '40px',
    marginBottom: '0px',
    marginRight: 'auto',
    marginTop: '2em',
    textTransform: "none",
    '&:hover': {
        background: '#444444',
        color: '#fff',
        border: '1px solid #444444'
    }
}))

const About = [
    { title: 'About Us', },
    { title: 'Reviews', },
    { title: 'Meet The Team', },
    { title: 'Real Prop vs. Traditional Agents', },
    { title: 'Real Prop vs. FSBO', },
    { title: 'FAQ', },
    { title: 'Careers', },
    { title: 'Privacy Policy', },
]

const Locations = [
    { title: 'Arizona', },
    { title: 'California', },
    { title: 'Colorado', },
    { title: 'Georgia', },
    { title: 'Illinois', },
    { title: 'North Carolina', },
    { title: 'South Carolina', },
    { title: 'Washington', },
]


const Footer = () => {
    const matches = useMediaQuery('(max-width:600px)');
    return (
        <footer>
            <Paper elevation={0} sx={{ bgcolor: '#F4F3F2' }}>
                <Grid container spacing-={2} sx={{ p: matches ? '2em' : '5em 15em' }}>
                    <Grid item xs={matches ? 12 : 3}>
                        <Link
                            component={RouterLink}
                            to="/"
                            sx={{ textDecoration: 'none' }}
                        >
                            <Box
                                component="img"
                                sx={{
                                    height: 120, // Adjust the height as needed
                                    width: 180, // This will maintain the aspect ratio
                                }}
                                alt="Logo"
                                src={`${logo}`} // Replace with the path to your logo
                                onClick={() => history(`/`)}
                            />
                        </Link>
                    </Grid>
                    <Grid item xs={matches ? 7 : 3} >
                        <Typography
                            variant="body1"
                            sx={{
                                fontWeight: 300,
                                textAlign: 'justify',
                                mb: '1em',
                            }}>
                            ABOUT US
                        </Typography>
                        {
                            About.map((item) => {
                                return (
                                    <Typography variant="body2" sx={{
                                        fontWeight: 400,
                                        textAlign: 'justify',
                                        lineHieght: '1.5em',
                                    }} key={item.title}>
                                        {item.title}
                                    </Typography>
                                )
                            })
                        }
                    </Grid>
                    <Grid item xs={matches ? 5 : 3} >
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 300,
                                textAlign: 'justify',
                                mb: '1em',
                                ml: matches ? '1em' : null
                            }}>
                            LOCATIONS
                        </Typography>
                        {
                            Locations.map((item) => {
                                return (
                                    <Typography variant="body2" sx={{
                                        fontWeight: 400,
                                        textAlign: 'justify',
                                        lineHieght: '1.5em',
                                        ml: matches ? '1em' : null
                                    }} key={item.title}>
                                        {item.title}
                                    </Typography>
                                )
                            })
                        }
                    </Grid>
                    <Grid item xs={matches ? 12 : 3} display='flex' flexDirection="column" justifyContent={matches ? "center" : "start"} alignItems={matches ? "center" : "start"} sx={{ mt: matches ? '1em' : 0 }}>
                        <Button variant={matches ? "contained" : "outlined"}
                            component={Link}
                            href="tel:425-533-3269"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: 'center',
                                alignItems: 'start',
                                width: '250px',
                                height: '50px',
                                padding: '2.5em',
                                color: '#fff',
                                fontSize: '14px',
                                background: matches ? '#EFE8E5' : 'none',
                                border: matches ? 'none' : '1px solid #4B4B4B',
                                borderRadius: '10px',
                                '&:hover': {
                                    background: matches ? '#EFE8E5' : 'none',
                                    color: 'fff',
                                    borderColor: '#978A7D',
                                }
                            }}>
                            <Typography sx={{ textTransform: 'capitalize', textAlign: 'left', fontSize: 16, fontWeight: 500 }}>Call Us</Typography>
                            <Typography variant="h7" sx={{ textTransform: 'capitalize', textAlign: 'left', color: '#978A7D', fontWeight: 600 }}>
                                425-533-3269
                            </Typography>
                        </Button>
                            <Button variant={matches ? "contained" : "outlined"}
                             component={Link}
                             href="mailto:realprop@gmail.com"
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: 'center',
                                    alignItems: 'start',
                                    mt: '2em',
                                    padding: '2.5em',
                                    width: '250px',
                                    height: '50px',
                                    color: '#fff',
                                    fontSize: '14px',
                                    background: matches ? '#EFE8E5' : 'none',
                                    border: matches ? 'none' : '1px solid #4B4B4B',
                                    borderRadius: '10px',
                                    '&:hover': {
                                        background: matches ? '#EFE8E5' : 'none',
                                        color: 'fff',
                                        borderColor: '#978A7D',
                                    }
                                }}>
                                <Typography sx={{ textTransform: 'capitalize', textAlign: 'left', fontSize: 16, fontWeight: 500 }}>Email Us</Typography>
                                <Typography variant="h7" sx={{ textTransform: 'lowercase', textAlign: 'left', color: '#978A7D', fontWeight: 600 }}>
                                    realprop@gmail.com
                                </Typography>
                            </Button>
                        <Stack direction="row" sx={{ mt: '2em' }}>
                            <IconButton>
                                <FacebookIcon sx={{ color: '#978A7D' }} />
                            </IconButton>
                            <IconButton>
                                <TwitterIcon sx={{ color: '#978A7D' }} />
                            </IconButton>
                            <IconButton>
                                <InstagramIcon sx={{ color: '#978A7D' }} />
                            </IconButton>
                            <IconButton>
                                <LinkedInIcon sx={{ color: '#978A7D' }} />
                            </IconButton>
                        </Stack>
                        {matches ?
                            <Stack display="flex" justifyContent="center" alignItems="center">
                                <StyledBtn>
                                    Contact Us Today
                                </StyledBtn>
                            </Stack>
                            :
                            <StyledBtn>
                                Contact Us Today
                            </StyledBtn>}
                    </Grid>
                </Grid>
            </Paper>
        </footer >
    )
}

export default Footer